import { render } from "./fusoSC.vue?vue&type=template&id=aa2c6064&scoped=true"
import script from "./fusoSC.vue?vue&type=script&lang=js"
export * from "./fusoSC.vue?vue&type=script&lang=js"

import "./fusoSC.vue?vue&type=style&index=0&id=aa2c6064&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa2c6064"]])

export default __exports__